import React, { Component } from 'react'
import ToolTip from '../../../../common/elements/ToolTip';
import PropTypes from 'prop-types';
import Ionicon from 'react-ionicons';

class ProfileCompletion extends Component {
    render() {
        const { content } = this.props;
        return (
            <div id="visibility" className="user-visibility profile-completion__fields">
                <div className="container">
                    <div className="row profile-visibility-box">
                        <div className="col-12">
							<b className="p-tag section-visibility-info has-color-orange">In order to receive a star for completing your profile, these fields must be filled in</b>
                            {content && content.map((section, i) => {
                                let icon = section.complete ? 'checkmark' : 'close';
                                return (
                                    <div key={i} className="col-xs-6 tooltips-content__inner">
                                        <span key={i}>
                                            <Ionicon className={`icon-${icon}`} icon={`ion-${icon}`} />
                                            <span className="section-name">{section.name}</span>
                                        </span>
                                    </div>
                                );
                            })}
                            </div>
                        </div>
                    </div>
            </div>
        );
    }
}

ProfileCompletion.propTypes = {
    content: PropTypes.array
};

export default ProfileCompletion;


// WEBPACK FOOTER //
// src/client/components/site/features/profile/components/ProfileCompletion.js